import PageBase from "./PageBase";
import React from "react";
import { authRequest } from "../../api/auth.js";
import { host } from "../../config.js";
import {variant_table} from "../../settings.js";
import {Oval} from '@agney/react-loading'
import {Nav, Table, Container, Row, Col, Form} from 'react-bootstrap';
import {Link} from "react-router-dom";
import { BrowserView, MobileView, isMobile } from "react-device-detect"

export default class Companies extends PageBase {
    state = {
        companies_loading: true,
        companies: [],
        companies_filtered: [],
        count : 0
    }

    setCompanies(queryParams){
        authRequest.get("http://"+host+":8000/api/companies",{ params: {}}) //WithAuth
            .then(res => {
                const companies = res.data.results;
                const count = res.data.count;
                this.setState({ companies });
                this.setState({ count });
                this.setState({ companies_loading: false });
                this.setState({companies_filtered: companies});
            })
    }
    componentDidMount() {
        let queryParams = new URLSearchParams(window.location.search);
        this.setCompanies(queryParams);
    }

    filterList = (e) => {
        const filtered = this.state.companies.filter((company_filtered) => {
            return company_filtered.code.toLowerCase().search( e.target.value.toLowerCase()) !== -1
            || (company_filtered.name_ja !== null && company_filtered.name_ja.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.name_ja_ruby !== null && company_filtered.name_ja_ruby.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.industry_ja !== null && company_filtered.industry_ja.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.fund_family_ja !== null && company_filtered.fund_family_ja.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.description_ja !== null && company_filtered.description_ja.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.name !== null && company_filtered.name.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.industry !== null && company_filtered.industry.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.fund_family !== null && company_filtered.fund_family.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            || (company_filtered.description !== null && company_filtered.description.toLowerCase().search( e.target.value.toLowerCase()) !== -1)
            ;
        })
        this.setState({companies_filtered: filtered})
    }

    render() {
        let date = new Date();
        date.setFullYear(date.getFullYear()-1)
        //let date_from = date.toISOString().substring(0, 10)
        let companies = this.state.companies_filtered;
        console.log('this.state.loading',this.state.loading);
        const style_loading = {"height":"100vh"};
        const style = {
            "font-family": "Meiryo,Hiragino Sans,Hiragino Kaku Gothic ProN,Meiryo,sans-serif,Emoji;",
            "height":"100%"
        };
        //const style = {hight: 100%};
        if (isMobile){}
        if (this.state.companies_loading){
            let r = (
            <Container style={style_loading}>
                <Row class="mt-5"><Col class="col-md-12">&nbsp;</Col></Row>
                <Row>
                    <Col class="col-md-4"></Col>
                    <Col class="col-md-4"><Oval width="250" color="#3db70f"/></Col>
                    <Col class="col-md-4"></Col>
                </Row>
                <Row class="mt-5"><Col class="col-md-12">&nbsp;</Col></Row>
            </Container>);
            return this.redirectLogin('/login', r);
        }else{
            let r = (
                <Container style={style}class="pt-3">
                <Row class = "center-block">
                    <div class="col-md-12 bg-secondary text-center">
                        <h2 class="text-light">銘柄一覧</h2>
                              <MobileView>
                                <p>Mobile content</p>
                              </MobileView>
                              <BrowserView>
                                <p>None mobile content</p>
                              </BrowserView>
                    </div>
                    <div class="text-center  center-block" style={{ margin: "0 auto" }}>
                        <Form action="">
                            <div class="col-md-4 "> <Form.Control class="form-control col-md-4" placeholder="Search" onChange={this.filterList}/></div>
                            <div class="col-md-4">{companies.length} result(s)</div>
                        </Form>
                    </div>
                </Row>
                    <Table striped bordered hover variant={variant_table}>
                        <thead>
                            <tr>
                                <th scope="col">Code</th>
                                <th scope="col">Name(JA)</th>
                                <th scope="col"><BrowserView>Market</BrowserView></th>
                                <th scope="col"><BrowserView>Industry(JA)</BrowserView></th>
                                <th scope="col"><BrowserView>Description(JA)</BrowserView></th>
                                <th scope="col">Links</th>
                            </tr>
                        </thead>
                        <tbody>
                            {companies.map(r =>
                                <tr class="table-sm">
                                    <td><Nav.Link as={Link} to={`/weekly_price/?code=${r.code}`} target="_blank">{r.code}</Nav.Link></td>
                                    <td class="text-left" >{r.name_ja}</td>
                                    <td className="text-left"><BrowserView>{r.market}</BrowserView></td>
                                    <td className="text-left"><BrowserView>{r.industry_ja}</BrowserView></td>
                                    <td className="text-left"><BrowserView>{r.description_ja}</BrowserView></td>
                                    <td class="text-left"><a className="custom-style" href={`https://finance.yahoo.co.jp/quote/${r.code}`} rel="noopener noreferrer" target="_blank">Y!JP</a></td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Container>
            );
            return this.redirectLogin('/login', r);
        }
    }
}
